import * as z from "zod/v4";

export const AskRedoEmergencyModeConfigSchema = z.object({
  enabled: z.boolean(),
  message: z.string(),
  updatedAt: z.string().nullable(),
  updatedBy: z.string().nullable(),
});

export type AskRedoEmergencyModeConfig = z.infer<
  typeof AskRedoEmergencyModeConfigSchema
>;

export const getAskRedoEmergencyMode = {
  name: "getAskRedoEmergencyMode" as const,
  input: z.object({}),
  output: z.object({ emergencyMode: AskRedoEmergencyModeConfigSchema }),
};

export const updateAskRedoEmergencyMode = {
  name: "updateAskRedoEmergencyMode" as const,
  input: z.object({
    enabled: z.boolean(),
    expectedEnabled: z.boolean(),
    expectedUpdatedAt: z.string().nullable(),
    message: z.string(),
  }),
  output: z.object({ emergencyMode: AskRedoEmergencyModeConfigSchema }),
};
